import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';

/**
 * Navigate to order summary page based on current route context
 * If current URL contains /web/, stay on the same URL with query params and clear cart
 * Otherwise, navigate to /orderSummary page
 *
 * @param router - Next.js router instance
 * @param orderId - Order ID to include in query params
 * @param paymentStatus - Payment status (default: 'success')
 * @param dispatch - Optional dispatch function to clear cart data
 * @param setCartState - Optional function to close cart drawer
 * @param cartState - Optional current cart state
 */
export const navigateToOrderSummary = (
  router: AppRouterInstance,
  orderId: string,
  paymentStatus: string = 'success',
  dispatch?: any,
  setCartState?: any,
  cartState?: any,
) => {
  const currentPath = window.location.pathname;

  if (currentPath.includes('/web/')) {
    // Stay on the same URL and add query parameters
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('orderId', orderId);
    currentUrl.searchParams.set('payment_status', paymentStatus);

    // Use router.push with the updated URL
    router.push(currentUrl.pathname + currentUrl.search);

    // Clear cart and localStorage if this is the current draft order
    if (orderId === localStorage.getItem('draft_orderID')) {
      // Clear localStorage items
      localStorage.removeItem('CheckoutId');
      localStorage.removeItem('discount');
      localStorage.removeItem('draft_orderID');
      localStorage.removeItem('discountCode');
      localStorage.removeItem('discount_value');
      localStorage.removeItem('discount_value_type');

      // Clear cart data if dispatch is provided
      if (dispatch) {
        // Import setCartData dynamically to avoid circular dependencies
        import('@/core/store/productContext/product-reducers').then(({ setCartData }) => {
          dispatch(
            setCartData({
              dataObj: [],
            }),
          );
        });
      }

      // Close cart drawer if setCartState is provided
      if (setCartState && cartState) {
        setCartState({ ...cartState, open: false });
      }
    }
  } else {
    // Navigate to orderSummary page as before
    router.push(`/orderSummary?orderId=${orderId}&payment_status=${paymentStatus}`);
  }
};
